<form #form="ngForm" (ngSubmit)="onSubmit(form)">
    <div class="form-row">
        <input required email type="email" name="email" [(ngModel)]="model.email" placeholder="{{ 'shared.label.email' | translate }}"  />
    </div>

    <div class="form-row">
        <button [disabled]="form.form.invalid" class="button button-full-width button-big button-primary">{{ 'auth.login.button.login' | translate }}</button>
    </div>

    <div class="form-row form-row-split">
        <a class="form-signup" routerLink="/signup">{{ 'auth.login.signup' | translate }}</a>
        <a class="form-login-sso" routerLink="/login">{{ 'auth.login.login-back' | translate }}</a>
    </div>
</form>
